import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="font-serif font-bold text-3xl mb-4">{t("common.siteName")}</h3>
            <p className="text-foreground-200 text-sm leading-relaxed max-w-xs">
              {t("common.footer.description")}
            </p>
            <div className="flex items-center space-x-4 mt-6">
              <a
                href="http://9mzg.cn/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center hover:border-white hover:bg-white/10 transition-all duration-200"
                aria-label={t("common.footer.weibo")}
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="http://9mzg.cn/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center hover:border-white hover:bg-white/10 transition-all duration-200"
                aria-label={t("common.footer.wechat")}
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a
                href="http://9mzg.cn/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center hover:border-white hover:bg-white/10 transition-all duration-200"
                aria-label={t("common.footer.douyin")}
              >
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a
                href="http://9mzg.cn/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center hover:border-white hover:bg-white/10 transition-all duration-200"
                aria-label={t("common.footer.bilibili")}
              >
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="space-y-8">
            <div>
              <h4 className="text-xs uppercase tracking-widest text-foreground-400 mb-3">
                {t("common.footer.contactTitle")}
              </h4>
              <p className="text-foreground-200 text-sm">{t("common.footer.address")}</p>
              <p className="text-foreground-200 text-sm mt-1">{t("common.footer.contactEmail")}</p>
              <p className="text-foreground-200 text-sm mt-1">{t("common.footer.contactPhone")}</p>
            </div>
            <div>
              <h4 className="text-xs uppercase tracking-widest text-foreground-400 mb-3">
                {t("common.footer.businessTitle")}
              </h4>
              <p className="text-foreground-200 text-sm">{t("common.footer.businessEmail")}</p>
            </div>
            <div>
              <h4 className="text-xs uppercase tracking-widest text-foreground-400 mb-3">
                {t("common.footer.reportTitle")}
              </h4>
              <p className="text-foreground-200 text-sm">{t("common.footer.reportEmail")}</p>
            </div>
          </div>

          <div>
            <div className="w-full aspect-[3/4] rounded-lg overflow-hidden bg-foreground-800">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20office%20building%20exterior%20at%20dusk%20with%20warm%20golden%20lighting%2C%20clean%20architectural%20lines%2C%20professional%20atmosphere%2C%20editorial%20photography%20with%20soft%20shadows%20and%20elegant%20composition&width=400&height=533&seq=footer-image&orientation=portrait"
                alt="51吃瓜网办公楼"
                className="w-full h-full object-cover object-top"
                title="51吃瓜网北京总部"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">{t("common.footer.copyright")}</p>
          <div className="flex items-center space-x-6">
            <a href="/privacy" className="text-foreground-400 text-xs hover:text-foreground-200 transition-colors whitespace-nowrap">
              {t("common.footer.privacy")}
            </a>
            <a href="/terms" className="text-foreground-400 text-xs hover:text-foreground-200 transition-colors whitespace-nowrap">
              {t("common.footer.terms")}
            </a>
            <a href="/disclaimer" className="text-foreground-400 text-xs hover:text-foreground-200 transition-colors whitespace-nowrap">
              {t("common.footer.disclaimer")}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
